import { AuthContext } from 'context/authContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function Useaddleavetype(cb) {

  const { authDispatch } = useContext(AuthContext);

  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.LEAVETYPES_API,
        data
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
        authDispatch({
          type: 'UPDATE_FIRSTLOGIN',
          payload: false
        })
        SuccessToast({ text: data.message });
        cb();
        queryClient.invalidateQueries('get-leave-types');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
